<div *ngIf="!isAdditionalWebsite"
     class="db-websites-controls-card" [ngClass]="{'disabled': disabled}">
  <div class="main-wrap">
    <div>
      <i *ngIf="icon" class="db-icon db-icon-{{icon}} card-icon"></i>
    </div>
    <p [innerHTML]="title"></p>
  </div>
</div>

<div *ngIf="isAdditionalWebsite" class="db-websites-controls-card" [ngClass]="{'disabled': disabled}">
  <div>
    <div>
      <p [innerHTML]="title"></p>
    </div>
  </div>
  <div class="footer">
    <a class="ds-link-new">
      <span *ngIf="isAdditionalWebsite">Buy now</span>
    </a>
  </div>
</div>
